import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { GeneralService } from '../services/general.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const generalService = inject(GeneralService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('🔥 ErrorInterceptor:', error);

      // 🌐 Error de red / CORS / backend caído
      if (error.status === 0) {
        generalService.viewSnacAlert(
          'No se pudo conectar con el servidor',
          'error',
          'Error de red',
        );
        return throwError(() => error);
      }

      // 🔐 No autorizado
      // if (error.status === 401) {
      //   const refreshToken = localStorage.getItem('refreshToken');
      //   const token = localStorage.getItem('token');

      //   if (!refreshToken || !token) {
      //     authService.logout();
      //     return throwError(() => error);
      //   }

      //   return authService
      //     .refreshToken({
      //       token,
      //       refreshToken,
      //       origin: window.location.origin,
      //     })
      //     .pipe(
      //       switchMap((response) => {
      //         if (!response?.accessToken) {
      //           authService.logout();
      //           return throwError(() => error);
      //         }
      //         localStorage.setItem('token', response.accessToken);
      //         localStorage.setItem('refreshToken', response.refreshToken);
      //         // Reintentar request original
      //         const retryReq = req.clone({
      //           setHeaders: {
      //             Authorization: `Bearer ${response.accessToken}`,
      //           },
      //         });

      //         return next(retryReq);
      //       }),
      //       catchError(() => {
      //         authService.logout();
      //         return throwError(() => error);
      //       }),
      //     );
      // }
      // 💥 Error interno
      if (error.status === 500) {
        generalService.viewSnacAlert('Ha ocurrido un error en el servicio', 'error', 'Ha ocurrido');
      }

      return throwError(() => error);
    }),
  );
};
